var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1488 -266)"},React.createElement("path",{"d":"M16.45,2.247l5.3,5.3L8.982,20.321h-5.3v-5.3Zm0,2.121L14.673,6.145l3.182,3.182L19.632,7.55Zm.345,6.019L13.612,7.205,5.179,15.639v3.182H8.361Z","fill":"currentColor","transform":"translate(1491.321 270.753)","fillRule":"evenodd"})));
}

Edit.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Edit;

Edit.default = Edit;
